import './mobile-post-carousel.component.scss';
import { buttonize } from '../../../../utils/a11y.utils';
import { useTranslation } from '../../../../i18n';

import { h } from 'preact';
import { createPortal } from 'preact/compat';
import { useEffect, useRef, useState } from 'preact/hooks';

import { getMobileStack } from '../../perks-nav/mobile-stack';
import { apCarouselSlot, commentCarouselSlot } from './mobile-carousel-slots';

export const MobilePostCarousel = () => {
  const { t } = useTranslation();
  const trackRef = useRef<HTMLDivElement>(null);
  const commentSlideRef = useRef<HTMLDivElement>(null);
  const apSlideRef = useRef<HTMLDivElement>(null);
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    commentCarouselSlot.value = commentSlideRef.current;
    apCarouselSlot.value = apSlideRef.current;

    return () => {
      commentCarouselSlot.value = null;
      apCarouselSlot.value = null;
    };
  }, []);

  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const slideWidth = track.offsetWidth;
    setActiveSlide(track.scrollLeft > slideWidth / 2 ? 1 : 0);
  };

  const scrollToSlide = (i: number) => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollTo({ left: i * track.offsetWidth, behavior: 'smooth' });
  };

  const carousel = (
    <div class="single-mobile-post-carousel">
      <div class="carousel-dots">
        <span
          class={`dot${activeSlide === 0 ? ' active' : ''}`}
          {...buttonize(() => scrollToSlide(0), t('a11y.goToSlide', { number: '1' }))}
          aria-current={activeSlide === 0}
        />
        <span
          class={`dot${activeSlide === 1 ? ' active' : ''}`}
          {...buttonize(() => scrollToSlide(1), t('a11y.goToSlide', { number: '2' }))}
          aria-current={activeSlide === 1}
        />
      </div>
      <div class="carousel-track" ref={trackRef} onScroll={handleScroll}>
        <div class="carousel-slide" ref={commentSlideRef} />
        <div class="carousel-slide" ref={apSlideRef} />
      </div>
    </div>
  );

  const stack = getMobileStack();
  return stack ? createPortal(carousel, stack) : carousel;
};
